module.exports = __webpack_public_path__ + "static/media/S3N11-2.c35c5220.svg";